import { render, staticRenderFns } from "./twitter.vue?vue&type=template&id=57adb5c2&scoped=true&"
import script from "./twitter.vue?vue&type=script&lang=js&"
export * from "./twitter.vue?vue&type=script&lang=js&"
import style0 from "./twitter.vue?vue&type=style&index=0&id=57adb5c2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57adb5c2",
  null
  
)

export default component.exports